// extracted by mini-css-extract-plugin
module.exports = {"subSection":"ReportSummary_subSection__1EVsY","subSectionField":"ReportSummary_subSectionField__BDtJc"};